import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule, registerLocaleData } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MetaModule } from '@ngx-meta/core';
import { SimpleNotificationsModule } from 'angular2-notifications';
import localePt from '@angular/common/locales/pt';
import { Angulartics2Module } from 'angulartics2';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { AppRouter } from './app.router';
import { FormsModule } from '@angular/forms';
import { GtagModule } from 'angular-gtag';

registerLocaleData(localePt, 'pt-BR');

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    CommonModule,
    //RestritoModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    AppRouter,
    MetaModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    Angulartics2Module.forRoot(),
    FormsModule,
    GtagModule.forRoot({ trackingId: 'GTM-NDC5CJT', trackPageviews: true }),

  ],
  declarations: [
    AppComponent,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'pt-BR' }],
  bootstrap: [AppComponent],
})
export class AppModule { }
